// extracted by mini-css-extract-plugin
export var activityContainer = "_ns-0";
export var typingIndicatorContainer = "_ns-1";
export var typingIndicatorDot = "_ns-2";
export var wave = "_ns-3";